export default __webpack_public_path__ + "static/media/construction_equipment_expert.e471c80e.png";